import { ODATA_FILTER_GROUP_NAME } from "@/models/CaseSearchResult";

import type { Column } from "@/models/Column";

export function getFieldNames(fieldPath: string, filterConfig: Column["filterConfig"]) {
  if (filterConfig == null) throw new Error("Column is not filterable");

  const group =
    filterConfig?.filterGroup == null || (filterConfig.filterGroup as string) === ""
      ? ODATA_FILTER_GROUP_NAME
      : filterConfig.filterGroup;

  return {
    get fieldTypeName() {
      return `${group}[${fieldPath}][type]`;
    },
    get fieldValueName() {
      return `${group}[${fieldPath}][value]`;
    },
    get fieldParseAsName() {
      return `${group}[${fieldPath}][parseAs]`;
    },
    get fieldIsCollectionName() {
      return `${group}[${fieldPath}][isCollection]`;
    },
    get fieldToValueName() {
      return `${group}[${fieldPath}][value][to]`;
    },
    get fieldFromValueName() {
      return `${group}[${fieldPath}][value][from]`;
    },
    get fieldHelpTextId() {
      return `${group}-${fieldPath.replace(/[^a-zA-Z0-9]/g, "-")}-help`;
    },
  };
}
